exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dashboard {\n    margin-top: 20px;\n    padding: 0 40px;\n}\n.dashboard .row {\n    margin-bottom: 20px;\n}\n.chart {\n    padding-top: 20px;\n    padding-left: 10px;\n    background: #fff;\n    border: 1px solid #ddd;\n    box-shadow: 0 22px 35px -16px rgba(0, 0, 0, 0.1);\n}\n", ""]);

// exports
